// extracted by mini-css-extract-plugin
export default {"container":"m5-z"};